import { defineRouting } from 'next-intl/routing'
import { getBrandName } from '../utils/buildUtils'

export const locales = ['en', 'ar'] as const
export const routing = defineRouting({
    // A list of all locales that are supported
    locales,
    // Used when no locale matches
    defaultLocale: getBrandName() === 'flyin' ? 'ar' : 'en',
    // Disable automatic locale detection (we'll handle it manually in middleware)
    localeDetection: false
})
